// Azure AD Configuration
// IMPORTANT: Replace these placeholder values with your actual Azure AD app registration details
// You can find these values in the Azure Portal under Azure Active Directory > App registrations

const clientId =
  process.env.REACT_APP_AZURE_CLIENT_ID || "5a0e4d22-990a-4e31-9f7a-43ee3cc98967";

export const azureConfig = {
  clientId,
  tenantId: process.env.REACT_APP_AZURE_TENANT_ID || "f7ba65c3-a978-43d7-be8f-396a787858f6",
  redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
  logoutRedirectUri:
    process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI ||
    process.env.REACT_APP_REDIRECT_URI ||
    "http://localhost:3000",
  // Scope exposed by our own app registration ("Expose an API" -> access_as_user).
  // The backend validates that the access token's audience matches this app, so we
  // must request a token for this scope instead of a Microsoft Graph token.
  apiScope: process.env.REACT_APP_API_SCOPE || `api://${clientId}/access_as_user`,
};

// Instructions to get these values:
// 1. Go to Azure Portal (https://portal.azure.com)
// 2. Navigate to Azure Active Directory > App registrations
// 3. Create a new registration or use an existing one
// 4. Copy the Application (client) ID
// 5. Copy the Directory (tenant) ID
// 6. Under Authentication, add http://localhost:3001 as a redirect URI
// 7. Under Certificates & secrets, create a new client secret if needed
